import { DataAttributes } from '../../../common';
import Icon from '../../Icon/Icon';
import Link from '../../Link';
import css from './DownloadAssetLink.css';

interface DownloadAssetLinkProps extends DataAttributes {
  name: string;
  url: string;
}

const DownloadAssetLink = ({ name, url, ...props }: DownloadAssetLinkProps) => {
  return (
    <Link href={url} target="_blank" className={css.DownloadAssetLink} preventDefault={false} {...props}>
      {name}
      <Icon name="download" className={css.icon} />
    </Link>
  );
};

export default DownloadAssetLink;
